
























































import { Component, Provide, Mixins } from 'vue-property-decorator';
import MixinChartRaw from '@/plugins/podolib/services/helper/mixins/chart/raw/index';

type TStep = {
  id: string;
  name: string;
  icon: string;
  data: string;
};

@Component
export default class ChartRawStancePhaseAverageValue extends Mixins(MixinChartRaw) {
  @Provide() steps: TStep[] = [
    {
      id: 'heel-strike',
      name: 'heel_strike',
      icon: 'pose_talon',
      data: 'heelStrike',
    },
    {
      id: 'toe-strike',
      name: 'toe_strike',
      icon: 'pose_orteils',
      data: 'flatFoot',
    },
    {
      id: 'heel-off',
      name: 'heel_off',
      icon: 'deco_talon',
      data: 'heelOff',
    },
    {
      id: 'toe-off',
      name: 'toe_off',
      icon: 'deco_orteils',
      data: 'toesOff',
    },
  ];

  get prosupValues() {
    return {
      values: {
        left: {
          heelStrike: this.values.left.aggregates.pronation_angle_foot_in.avg,
          flatFoot: this.values.left.aggregates.pronation_angle_FFI.avg,
          heelOff: this.values.left.aggregates.pronation_angle_FFO.avg,
          toesOff: this.values.left.aggregates.pronation_angle_foot_out.avg,
        },
        right: {
          heelStrike: this.values.right.aggregates.pronation_angle_foot_in.avg,
          flatFoot: this.values.right.aggregates.pronation_angle_FFI.avg,
          heelOff: this.values.right.aggregates.pronation_angle_FFO.avg,
          toesOff: this.values.right.aggregates.pronation_angle_foot_out.avg,
        },
      },
      comparisonValues: {
        left: this.compareValues
          ? {
              heelStrike: this.compareValues.left.aggregates.pronation_angle_foot_in.avg,
              flatFoot: this.compareValues.left.aggregates.pronation_angle_FFI.avg,
              heelOff: this.compareValues.left.aggregates.pronation_angle_FFO.avg,
              toesOff: this.compareValues.left.aggregates.pronation_angle_foot_out.avg,
            }
          : null,
        right: this.compareValues
          ? {
              heelStrike: this.compareValues.right.aggregates.pronation_angle_foot_in.avg,
              flatFoot: this.compareValues.right.aggregates.pronation_angle_FFI.avg,
              heelOff: this.compareValues.right.aggregates.pronation_angle_FFO.avg,
              toesOff: this.compareValues.right.aggregates.pronation_angle_foot_out.avg,
            }
          : null,
      },
    };
    /*return {
      values: {
        left: Object.keys(prosup.values.left).reduce((acc: any, key: any) => {
          acc[key] = parseFloat(this.$pdc.helper!.radToDeg(prosup.values.left[key].avg).toFixed(1));
          return acc;
        }, {}),
        right: Object.keys(prosup.values.right).reduce((acc: any, key: any) => {
          acc[key] = parseFloat(this.$pdc.helper!.radToDeg(prosup.values.right[key].avg).toFixed(1));
          return acc;
        }, {})
      },
      comparisonValues: this.compareValues
        ? {
            left: Object.keys(prosup.comparisonValues.left).reduce((acc: any, key: any) => {
              acc[key] = parseFloat(this.$pdc.helper!.radToDeg(prosup.comparisonValues.left[key].avg).toFixed(1));
              return acc;
            }, {}),
            right: Object.keys(prosup.comparisonValues.right).reduce((acc: any, key: any) => {
              acc[key] = parseFloat(this.$pdc.helper!.radToDeg(prosup.comparisonValues.right[key].avg).toFixed(1));
              return acc;
            }, {})
          }
        : null
    };*/
  }
}
